'use client';

import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { isH5HandleClient } from 'eco-design-micro/utils-base/isH5Handle';
import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import EcoImg from 'eco-design/base/eco-img';
import ArrowUpRight from './icons';
import './index.scss';

/** 整卡背景图 */
const BG_IMG = 'https://websiteoss.ecoflow.com/upload/image/1787797817811/pc.jpg';
const BG_IMG_H5 = 'https://websiteoss.ecoflow.com/upload/image/1787797924221/h5.jpg';

export default function Content({ id, data = {} }: ContentServerProps) {
    const { title, subTitle, btnText, bgColor = 'transparent' } = data;
    const { locale = 'us' } = getLocal();

    const openRegionPopup = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'pop_ups',
            button_name: btnText,
            title_name: title,
            __btn_id1: 'index-global-site-popup-btn',
            __btn_id2: `${locale}/region`,
            __btn_type: 'href',
        });

        if (isH5HandleClient()) {
            location.href = `/${locale}/region`;
            return;
        }
        EcoDesignEventsBus.emit('GlobalLocaleV1-region-open', 'forum pop up');
    };

    return (
        <GloLayout
            className={`editor-index-global-site-popup editor-index-global-site-popup-${id}`}
            id={id}
            data={data}
            floorName="index-global-site-popup"
            style={{ backgroundColor: bgColor }}
        >
            <div className="index-global-site-popup-wrapper">
                <div className="index-global-site-popup-card">
                    <EcoImg className="index-global-site-popup-bg" pc={BG_IMG} pad={BG_IMG} h5={BG_IMG_H5} />

                    <div className="index-global-site-popup-left">
                        {title && <div className="index-global-site-popup-title">{title}</div>}
                        {subTitle && <p className="index-global-site-popup-subtitle">{subTitle}</p>}

                        {btnText && (
                            <div className="index-global-site-popup-btn" onClick={openRegionPopup}>
                                <span>{btnText}</span>
                                <ArrowUpRight />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </GloLayout>
    );
}
